export default {"src":"/_next/static/media/box.1472854c.svg","height":230,"width":263,"blurWidth":0,"blurHeight":0};